import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userName, ipAddress, userLocation } from "../Univ.js";

function MaintenancePage() {
  const [rows, setRows] = useState([]);
  const [machines, setMachines] = useState([]);

  const [data, setData] = useState({
    machine_id: "",
    description: "",
    maintenance_date: "",
    cost: "0"
  });

  useEffect(() => {
    fetchMaintenances();
    fetchMachines();
  }, []);

  // Fetch all Maintenance records
  const fetchMaintenances = () => {
    axios.get(baseUrl + "maintenance/")
      .then(res => setRows(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch Maintenance data", "error"));
  };

  const fetchMachines = () => {
    axios.get(baseUrl + "machines/")
      .then(res => setMachines(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch Machines", "error"));
  };

  const inputHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  // Submit new maintenance record
  const formSubmit = () => {
    if (!data.machine_id || !data.description || !data.maintenance_date) {
      Swal.fire("Error", "Machine, Description, and Date are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("machine", data.machine_id);
    _formData.append("description", data.description);
    _formData.append("maintenance_date", data.maintenance_date);
    _formData.append("cost", data.cost || 0);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.post(baseUrl + "maintenance/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(response => {
      if (response.status === 200 || response.status === 201) {
        Swal.fire({
          title: "Maintenance Created",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });
        setData({
          machine_id: "",
          description: "",
          maintenance_date: "",
          cost: "0"
        });
        fetchMaintenances();
      }
    })
    .catch(() => Swal.fire("Error", "Something went wrong", "error"));
  };

  // Delete maintenance record
  const handleDelete = (id) => {
    Swal.fire({
      title: "Confirm",
      text: "Are you sure you want to delete this?",
      icon: "warning",
      confirmButtonText: "Yes",
      showCancelButton: true
    }).then(result => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "maintenance/" + id + "/")
          .then(() => {
            Swal.fire("Deleted", "Maintenance deleted", "success");
            fetchMaintenances();
          });
      }
    });
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    {
      field: "machine",
      headerName: "Machine",
      width: 150,
      renderCell: (params) => params.row.machine?.name || "Unknown"
    },
    { field: "description", headerName: "Description", flex: 2 },
    { field: "maintenance_date", headerName: "Date", width: 150 },
    { field: "cost", headerName: "Cost", width: 150 },
    {
      field: "edit",
      headerName: "Edit",
      renderCell: (params) => (
        <Link
          to={`/maintenance/edit/${params.row.id}`}
          target="_blank"
          className="btn btn-warning btn-sm"
        >
          Edit
        </Link>
      ),
      width: 120
    },
    {
      field: "delete",
      headerName: "Delete",
      renderCell: (params) => (
        <button
          onClick={() => handleDelete(params.row.id)}
          className="btn btn-danger btn-sm"
        >
          Delete
        </button>
      ),
      width: 120
    }
  ];

  return (
    <div className="container mt-4">

      {/* Form */}
      <div className="card p-4 mb-4">
        <h4>Add Machine Maintenance</h4>

        <select
          className="form-control mt-3"
          name="machine_id"
          value={data.machine_id}
          onChange={inputHandler}
        >
          <option value="">Select Machine</option>
          {machines.map(m => (
            <option key={m.id} value={m.id}>{m.name}</option>
          ))}
        </select>

        <textarea
          className="form-control mt-3"
          placeholder="Description"
          name="description"
          value={data.description}
          onChange={inputHandler}
        />

        <input
          type="date"
          className="form-control mt-3"
          name="maintenance_date"
          value={data.maintenance_date}
          onChange={inputHandler}
        />

        <input
          type="number"
          className="form-control mt-3"
          placeholder="Cost"
          name="cost"
          value={data.cost}
          onChange={inputHandler}
        />

        <button className="btn btn-success mt-3" onClick={formSubmit}>
          Submit
        </button>
      </div>

      {/* DataGrid */}
      <div className="card p-3">
        <DataGrid
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": { color: "primary.main" }
          }}
          rows={rows}
          columns={columns}
          pageSize={10}
          autoHeight
          components={{ Toolbar: GridToolbar }}
        />
      </div>

    </div>
  );
}

export default MaintenancePage;
